























import { Component, Prop, Vue } from 'vue-property-decorator';
import { TimeSpan } from '@/models/CalendarEntries';
import CalendarDay from '@/components/Retailer/BookingCalendar/CalendarDay.vue';

@Component({
    components: {
        CalendarDay
    }
})
export default class Calendar extends Vue {
    protected scrollStep: number = 0;
    protected dayMin: number = 0;
    @Prop() private times!: TimeSpan[];

    get daySpanStart(): number {
        // return 1 - (new Date().getDay());
        this.dayMin = Math.min(this.scrollStep, this.dayMin);
        return this.dayMin;
    }
    get activeDays(): Date[] {
        const returnArray: Date[] = [];
        for (let a = 0; a < this.times.length; a++) {
            const addDate: Date = new Date(this.times[a].startDate.split('T')[0]);
            if (!returnArray.some((x: Date) => x.getTime() === addDate.getTime())) {
                returnArray.push(addDate);
            }
        }
        return returnArray;
    }
    get scrollStepWidth(): number {
        const daysContainer: Element = this.$refs.daysList as Element;
        const dayContainer: Element = daysContainer.firstChild as Element;
        if (daysContainer !== undefined) {
            return dayContainer.clientWidth;
        } else {
            return 167;
        }
    }
    protected created() {
        const daysContainer = this.$refs.daysList;
    }
    private timeSpansPerDay(day: Date): TimeSpan[] {
        if (this.times.length > 0) {
            const timeStart = new Date(day).setHours(0);
            const timeEnd = new Date(day).setHours(24);
            return this.times.filter((s: any) => {
                const sStart = Date.parse(s.startDate);
                const sEnd = Date.parse(s.endDate);
                return sEnd <= timeEnd && sStart >= timeStart;
            });
        } else {
            return [] as TimeSpan[];
        }
    }
    private scrollNext() {
        this.scrollStep++;
        this.$nextTick(() => {
            const dayList: Element = this.$refs.daysList as Element;
            dayList.scrollLeft += this.scrollStepWidth;
        });
    }
    private scrollPrev() {
        this.scrollStep--;
        this.$nextTick(() => {
            const dayList: Element = this.$refs.daysList as Element;
            dayList.scrollLeft -= this.scrollStepWidth;
        });
    }
}
